// Import the functions you need from the SDKs you need
import { EventParams, getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAvAQwkfgM4rCEAoW7zmD17jGyedgwAVMo',
  authDomain: 'glam-bbomcontest.firebaseapp.com',
  projectId: 'glam-bbomcontest',
  storageBucket: 'glam-bbomcontest.appspot.com',
  messagingSenderId: '451136010745',
  appId: '1:451136010745:web:c62840428fc1c9ee15e528',
  measurementId: 'G-8HCT55C2SQ',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const sendEvent = (eventName: string, eventParams?: EventParams) => {
  logEvent(analytics, eventName, eventParams);
};

export { analytics, sendEvent };
